import { Injectable } from '@angular/core';
import { SimpleExcelModel } from '@app/shared/models/simple-excel.model';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class SimpleExcelService {

  constructor() { }

  /*** @description Servicio crear excel*/
  async simpleXLSX(config: SimpleExcelModel) {
    const workbook = new Workbook();
    let fileName = config.fileName;
    for (const sheet of config.sheets) {
        let columns = [];
        let keys = [];
        let data = sheet.data;
        for (const column of sheet.columns) { 
            columns.push(column.columnName);
            keys.push(column.columnKey);
        }
        let worksheet = workbook.addWorksheet(sheet.sheetName);

        if(sheet.header && sheet.header.length > 0){
            for (const elem of sheet.header) {
                worksheet.addRow([elem]).font = { bold: true };
            }
        }

        if(sheet.head_info && sheet.head_info.length > 0){
            for (const elem of sheet.head_info) {
                worksheet.addRow(elem).font = { bold: false };
            }
        }

        if(sheet.title){
            const title = worksheet.addRow(sheet.title);
            worksheet.mergeCells(title.number,1,title.number,sheet.data.length);
            title.getCell(1).alignment = { horizontal: 'center' };
        }


        if(sheet.lineBreak>0){
            Array.from({ length: sheet.lineBreak }, (v, i) => i + 1).forEach((element: number) => worksheet.addRow([]));
        }

        Array.from({ length: columns.length }, (v, i) => i + 1).forEach((element: number) => {
          worksheet.getColumn(element).width = 20;
        });
        worksheet.addRow(columns).font = { bold: true };
        let columnsNameRow: any = worksheet.lastRow;
        console.log('[simpleXLSX] data', data)
        data.forEach((item: any) => {
            let row: any = [];
            for (const key of keys) { row.push(item[key]); }
            worksheet.addRow(row);
        });

        if(sheet.footer && sheet.footer.length > 0){
            for (const elem of sheet.footer) {
                worksheet.addRow(elem).font = { bold: false };
            }
        }
    
        columnsNameRow.eachCell(function (cell: any , colNumber: number) {
          worksheet.getCell(cell.address).alignment = { vertical: 'middle', horizontal: 'center' };
          worksheet.getCell(cell.address).font = { color: { argb: 'FDFCFB' } };
          worksheet.getCell(cell.address).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '666666' },
            bgColor: { argb: '666666' },
          };
          worksheet.getCell(cell.address).alignment = {
            wrapText: true,
            vertical: 'middle',
            horizontal: 'center',
          };
        });
    }

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, `${fileName}.xlsx`);
    });
  }
 
}
